import { forwardRef, useEffect, useImperativeHandle, useRef } from 'react'
import { Outlet, useLocation, useNavigate, useParams } from 'react-router-dom'
import { Col, Empty, Input, Layout, Row } from 'antd'

import classNames from 'classnames'
import { useShallow } from 'zustand/react/shallow'
// import { useFileUrlPrefix } from 'shj-utils'
import useWorkOrderStore from '@/store/workOrder.ts'
import WorkOrderAppList from './WorkOrderAppList.tsx'

import styles from './index.module.less'
import WorkOrderList from './WorkOrderList.tsx'
import queryParse from '@/utils/queryParse.ts'
import { Scrollbars } from 'react-custom-scrollbars'
import ResizeWidthWrap from '@/components/ResizeWidthWrap'
import { workOrderPath } from '@/utils/workOrderPath.ts'

const WorkOrderLayout = forwardRef((props: any, ref) => {
  // const customTabsRef = useRef<any>({})
  //
  // useImperativeHandle(ref, () => ({
  //   ...customTabsRef.current,
  // }))
  const location = useLocation()
  const navigate = useNavigate()

  const {
    storeInit,
    storeData,
    fetchWorkOrderCollect,
    selectItem,
    setWorkOrderExpandKeys,
    selectItemByParams,
    selectWorkOrderApp,
    setWorkOrderPath,
    routeWorkOrderItem,
    routeBizWorkOrderItem,
  } = useWorkOrderStore(
    useShallow((state: any) => ({
      storeInit: state.init,
      storeData: state.data,
      fetchWorkOrderCollect: state.fetchWorkOrderCollect,
      selectItem: state.selectItem,
      setWorkOrderExpandKeys: state.setWorkOrderExpandKeys,
      selectItemByParams: state.selectItemByParams,
      selectWorkOrderApp: state.selectWorkOrderApp,
      setWorkOrderPath: state.setWorkOrderPath,
      routeWorkOrderItem: state.routeWorkOrderItem,
      routeBizWorkOrderItem: state.routeBizWorkOrderItem,
    }))
  )
  const searchParams: any = queryParse(location.search)
  const { tab, app, item, itemId, taskId, procInstId } = searchParams || {}

  useEffect(() => {
    storeInit()
    // console.log('searchParams', searchParams)
    if (location.pathname !== '/flow/empty') {
      if (tab) {
        // console.log(item || itemId)
        selectItemByParams(tab, app, item || itemId)
        setWorkOrderPath(location.pathname + location.search)
      } else {
        // return
        // 进入页面 默认选中第一条 工单
        selectWorkOrderApp(storeData.workOrderCollectTab[0]).then(workOrderData => {
          if (!taskId && !procInstId) {
            const firstItem = workOrderData.filter(d => d.procDefKey && d.procInstId || workOrderPath[d.workOrder?.bizType])[0]
            if (firstItem) {
              selectItem(firstItem)
              if (firstItem.procDefKey && firstItem.procInstId) {
                routeWorkOrderItem(firstItem, navigate, {
                  selectedTabKey: storeData.workOrderCollectTab[0],
                  replace: true,
                })
              } else {
                routeBizWorkOrderItem(firstItem, navigate)
              }
            }
          }
          // setWorkOrderPath(location.pathname + location.search)
          if (itemId) {
            selectItem({ id: itemId })
          }
        })
      }
    }

    setWorkOrderExpandKeys([tab || storeData.workOrderCollectTab[0]]) // 展开tab
    fetchWorkOrderCollect()
  }, [])

  const onAppSelect = (record, tab) => {}
  // console.log('workOrderCollect', storeData.workOrderAppSelected)
  return (
    <Layout style={{ borderRadius: '12px', height: '100%' }}>
      <Layout
        id="mainContainer"
        className={classNames(styles.layoutRightContent, styles.workOrderLayout)}
      >
        <Row wrap={false} style={{ minHeight: 'calc(100vh - 32px - 30px)' }} align="stretch">
          <Col style={{ width: 220 }}>
            <WorkOrderAppList onSelect={onAppSelect} />
          </Col>
          <Col>
            <ResizeWidthWrap minWidth={240} width={320} maxWidth={420}>
              <WorkOrderList />
            </ResizeWidthWrap>
          </Col>
          <Col flex={1}>
            <Layout.Content
              style={{
                margin: 0,
                // background: colorBgContainer,
              }}
              className={styles.layoutRightContentScroll}
            >
              <Scrollbars autoHide renderTrackHorizontal={() => <div></div>}>
                {/*{!storeData?.selectedItemId ? (*/}
                {/*  <Empty*/}
                {/*    image={Empty.PRESENTED_IMAGE_SIMPLE}*/}
                {/*    style={{*/}
                {/*      position: 'absolute',*/}
                {/*      top: '50%',*/}
                {/*      left: '50%',*/}
                {/*      transform: 'translate(-50%, -50%)',*/}
                {/*    }}*/}
                {/*  />*/}
                {/*) : (*/}
                {/*  <Outlet />*/}
                {/*)}*/}
                <Outlet />
              </Scrollbars>
            </Layout.Content>
          </Col>
        </Row>
      </Layout>
    </Layout>
  )
})

export default WorkOrderLayout
